var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
export var ButtonStyleType;
(function (ButtonStyleType) {
    ButtonStyleType[ButtonStyleType["Primary"] = 0] = "Primary";
    ButtonStyleType[ButtonStyleType["Secondary"] = 1] = "Secondary";
    ButtonStyleType[ButtonStyleType["Back"] = 2] = "Back";
})(ButtonStyleType || (ButtonStyleType = {}));
var StyledButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  margin: ", ";\n  padding: ", ";\n  border: none;\n  cursor: pointer;\n  width: 100%;\n  border-radius: ", "px;\n"], ["\n  background: ",
    ";\n  color: ",
    ";\n  font-weight: ",
    ";\n  font-size: ", ";\n  font-family: ",
    ";\n  margin: ", ";\n  padding: ", ";\n  border: none;\n  cursor: pointer;\n  width: 100%;\n  border-radius: ",
    "px;\n"])), function (props) {
    if (props.bgColorOverride && props.bgColorOverride.length > 0)
        return props.bgColorOverride;
    switch (props.styleType) {
        case ButtonStyleType.Primary:
            return props.theme.colors.primary;
        case ButtonStyleType.Secondary:
            return props.theme.colors.accent;
        case ButtonStyleType.Back:
            return props.theme.colors.background;
    }
}, function (props) {
    if (props.color) {
        return props.color;
    }
    switch (props.styleType) {
        case ButtonStyleType.Primary:
            return props.theme.colors.background;
        case ButtonStyleType.Secondary:
            return props.theme.colors.background;
        case ButtonStyleType.Back:
            return props.theme.colors.error;
    }
}, function (props) {
    switch (props.styleType) {
        case ButtonStyleType.Primary:
            return 700;
        case ButtonStyleType.Secondary:
            return 700;
        case ButtonStyleType.Back:
            return 400;
    }
}, function (props) { var _a; return _a = props.fontSize, (_a !== null && _a !== void 0 ? _a : '1rem'); }, function (props) {
    switch (props.styleType) {
        case ButtonStyleType.Primary:
            return props.theme.fonts.main;
        case ButtonStyleType.Secondary:
            return props.theme.fonts.main;
        case ButtonStyleType.Back:
            return props.theme.fonts.secondary;
    }
}, function (props) { var _a; return _a = props.margin, (_a !== null && _a !== void 0 ? _a : '1rem 0'); }, function (props) { var _a; return _a = props.padding, (_a !== null && _a !== void 0 ? _a : '1rem 2rem'); }, function (props) {
    switch (props.styleType) {
        case ButtonStyleType.Primary:
            return 0;
        case ButtonStyleType.Secondary:
            return 0;
        case ButtonStyleType.Back:
            return 5;
    }
});
function Button(_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.styleType, styleType = _c === void 0 ? ButtonStyleType.Primary : _c, props = __rest(_a, ["label", "styleType"]);
    return (React.createElement(StyledButton, __assign({ styleType: styleType }, props, { bgColorOverride: props.bgColorOverride }), props.labelOverride && props.labelOverride.length > 0
        ? props.labelOverride
        : label));
}
export default Button;
var templateObject_1;
